import { PageContainer } from "@/components/container/page-container";
import { PageTitleComponent } from "@/components/page-title";
import { PlanInfoIconLink } from "@/components/plan-methodology/plan-info-icon-link";
import { PlanMethodologyNote } from "@/components/plan-methodology/plan-methodology-note";
import { useGetCalorieBudget } from "@/hooks/requests/calorie-budget/use-get-calorie-budget";
import { CalorieLegend } from "@/pages/plans/calorie-budget/calorie-legend";
import { CaloriePlanCards } from "@/pages/plans/calorie-budget/calorie-plan-cards";
import { cn } from "@/utils/cn";
import { IonSpinner } from "@ionic/react";
import CaloriePieChart from "./calorie-pie-chart";

export default function CalorieBudgetPage() {
  const { calorieBudget, isLoading } = useGetCalorieBudget();

  if (isLoading) {
    return (
      <PageContainer className="items-center justify-center" showLogo={true}>
        <IonSpinner name="crescent" />
      </PageContainer>
    );
  }

  if (!calorieBudget) {
    return (
      <PageContainer className="items-center justify-center" showLogo={true}>
        <div>No calorie budget data available</div>
      </PageContainer>
    );
  }

  return (
    <PageContainer
      className="px-4 gap-8 app-bar-bottom-padding overflow-y-auto no-scrollbar"
      showLogo={true}
    >
      <div className="flex flex-col gap-4">
        <div className="flex items-center justify-between">
          <PageTitleComponent title="Calorie Budget" />
        </div>

        <CaloriePlanCards
          dailyCalories={calorieBudget.average_daily_calories}
          weeklyCalories={calorieBudget.weekly_calories}
        />

        <div className="w-full">
          <h6 className="text-2xl font-bold mb-6 flex items-center gap-2">
            Macronutrient Breakdown
            <PlanInfoIconLink to="/plans/methodology" />
          </h6>

          <div className="flex flex-col items-center gap-6">
            <CaloriePieChart
              proteinPercentage={calorieBudget.protein_pct}
              proteinColorClassName="fill-purple-200"
              carbsPercentage={calorieBudget.carb_pct}
              carbsColorClassName="fill-pink-100"
              fatPercentage={calorieBudget.fat_pct}
              fatColorClassName="fill-green-100"
              totalCalories={calorieBudget.average_daily_calories}
            />
            <div
              className={cn(
                "w-full flex flex-col gap-4",
                "[&>*:not(:last-child)]:border-b [&>*:not(:last-child)]:border-gray-100",
              )}
            >
              <CalorieLegend
                name="Protein"
                percentage={calorieBudget.protein_pct}
                colorClassName="bg-purple-200"
              />

              <CalorieLegend
                name="Carbs"
                percentage={calorieBudget.carb_pct}
                colorClassName="bg-pink-100"
              />

              <CalorieLegend
                name="Fat"
                percentage={calorieBudget.fat_pct}
                colorClassName="bg-green-100"
              />
            </div>
          </div>
        </div>
      </div>

      <PlanMethodologyNote />
    </PageContainer>
  );
}
